/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiConfiguration = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.5 15.145c.233.069.455.162.665.276l.81-.81 1.414 1.414-.81.81c.114.21.207.432.276.665H23v2h-1.145a3.44 3.44 0 0 1-.276.665l.81.81-1.414 1.414-.81-.81a3.44 3.44 0 0 1-.665.276V23h-2v-1.145a3.483 3.483 0 0 1-.665-.276l-.81.81-1.414-1.414.81-.81a3.483 3.483 0 0 1-.276-.665H14v-2h1.145a3.44 3.44 0 0 1 .276-.665l-.81-.81 1.414-1.414.81.81a3.44 3.44 0 0 1 .665-.276V14h2zM18.5 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" />
        <path d="M12 2a8 8 0 0 1 7.936 7H22v2h-2.063c-.055.44-.144.87-.268 1.285l-1.917-.57A6 6 0 1 0 12 16v2H7a2.998 2.998 0 0 0-2.826 2H12v2H2v-1a5 5 0 0 1 4.72-4.992A7.98 7.98 0 0 1 4.065 11H2V9h2.064A8 8 0 0 1 12 2z" />
        <path d="M10 12H8V8h2zm6 0h-2V8h2z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiConfiguration as AiConfiguration };
